<script>
export default {
    name: "SkokkaCarouselControls",
    methods: {
        handleOnClick(direction) {
            this.$emit("click", direction);
        },
    }
};
</script>

<template>
    <div class="carousel-controls">
        <button role="button" class="prev" @click="handleOnClick(-1)">&#10094;</button>
        <button role="button" class="next" @click="handleOnClick(1)">&#10095;</button>
    </div>
</template>
